import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHead } from "@/admin/AdminLayout";

const Stat = ({ label, value, to, testId }) => (
  <Link to={to || "#"} className="admin-card block p-5 transition-colors hover:border-white/25" data-testid={testId}>
    <p className="mono text-[0.58rem] text-[#8b95a5]">{label}</p>
    <p className="display-tight mt-3 text-3xl">{value ?? "–"}</p>
  </Link>
);

export default function Dashboard() {
  const { data: s } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  const lt = s?.leads_by_type || {};
  return (
    <div data-testid="admin-dashboard">
      <PageHead title="Dashboard" />
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="New leads" value={s?.new_leads} to="/admin/leads/contact" testId="stat-new-leads" />
        <Stat label="Published vehicles" value={s ? `${s.vehicles_published} / ${s.vehicles_total}` : null} to="/admin/vehicles" testId="stat-vehicles" />
        <Stat label="Sourcing requests" value={lt.sourcing || 0} to="/admin/leads/sourcing" testId="stat-sourcing" />
        <Stat label="Sell submissions" value={lt.sell || 0} to="/admin/leads/sell" testId="stat-sell" />
        <Stat label="Vehicle requests" value={lt.inquiry || 0} to="/admin/leads/inquiry" testId="stat-inquiry" />
        <Stat label="Messages" value={lt.contact || 0} to="/admin/leads/contact" testId="stat-contact" />
        <Stat label="Media files" value={s?.media_count} to="/admin/media" testId="stat-media" />
        <Stat label="Available vehicles" value={s?.vehicles_by_status?.available || 0} to="/admin/vehicles" testId="stat-available" />
      </div>
      <div className="admin-card mt-8 p-5">
        <p className="mono mb-4 text-[0.58rem] text-[#8b95a5]">Recent leads</p>
        <div className="divide-y divide-white/5">
          {s?.recent_leads?.map((l) => (
            <Link key={l.id} to={`/admin/leads/${l.type}`} className="flex items-center justify-between gap-4 py-3 text-sm hover:text-white">
              <span className="truncate">{l.name} <span className="text-[#8b95a5]">— {l.vehicle || l.type}</span></span>
              <span className="mono shrink-0 text-[0.55rem] text-[#8b95a5]">{l.status} · {l.created_at?.slice(0, 10)}</span>
            </Link>
          ))}
          {s && !s.recent_leads?.length && <p className="py-3 text-sm text-[#8b95a5]">No leads yet.</p>}
        </div>
      </div>
    </div>
  );
}
